/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2ClockInTaskIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2ClockInTaskIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2ClockInTaskIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#5C0C62"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2ClockInTaskIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-ZiABpF': alignSelf,'--mt-2-ZiABpF': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZiABpF': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZiABpF': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZiABpF': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZiABpF': opacity,'--w-10-ZiABpF': typeof width === 'number' ? `${width}px` : width,'--h-11-ZiABpF': typeof height === 'number' ? `${height}px` : height,'--f-12-ZiABpF': fill,'--a-7-ZiABpF': isAnimated ? animation : "none",'--sd-8-ZiABpF': isAnimated ? strokeDashoffset : 0,'--sd-9-ZiABpF': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2ClockInTaskIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M5.786 1.286a1.286 1.286 0 00-2.572 0V2.57H1.93A1.929 1.929 0 000 4.5v11.571C0 17.137.863 18 1.929 18H16.07A1.929 1.929 0 0018 16.071V4.5a1.929 1.929 0 00-1.929-1.929h-1.285V1.286a1.286 1.286 0 10-2.572 0V2.57H5.786V1.286zm7.714 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM9.804 9a.804.804 0 10-1.608 0v1.607c0 .369.251.69.61.78l1.285.321a.804.804 0 00.39-1.559l-.677-.17V9z"
 style={{'--f-12-ZiABpF': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}